module.exports = __webpack_public_path__ + "static/media/mobile-app-self-check-in-es.4b04b48b.png";